<script lang="ts">
	import getMediaUrl from '$lib/helpers/getMediaUrl';
	import userImg from '$lib/assets/images/user.svg';

	export let src = undefined as string | undefined;
</script>

<img
	src={src ? getMediaUrl(src) : userImg}
	alt=""
	class="w-10 h-10 rounded-full shrink-0 object-cover {$$props.class}"
/>
